<template>
  <!-- <div class="learning"> -->
  <div class="prctice">
    <div
      v-if="isIE"
      class="scrtc_ie_header"
    ></div>
    <Header
      v-else
      :value="scrtc_iframe"
      v-on:close-loading="closeLoading"
    />
    <div
      v-if="isIE"
      class="scrtc_main"
    >
      <div class="scrtc_ie_broswer">
        <div class="scrtc_ie_broswer_header"></div>
        <div class="scrtc_ie_broswer_contents">
          <h2><span>해당 브라우저는 지원되지 않습니다. </span></h2>
        </div>
        <div class="scrtc_ie_broswer_footer">
          스크래치는 인터넷 익스플로러(Internet Explorer)를 지원하지 <br />않습니다. 구글 크롬(Chrome), 모질라 파이어폭스(Firefox), 마이크로 <br />소프트 엣지(Edge)와 같은 브라우저를 사용하시기 바랍니다.
        </div>
      </div>
    </div>
    <div
      v-else
      class="scrtc_main"
    >
      <div :class="`scrtc_loading_${isLoading ? 'show' : 'hide'}`">
        <div class="loading_text">{{ txtLoading }}</div>
      </div>
      <iframe
        id="scrtc_iframe"
        class="scrtc_iframe_show"
        allow="auto"
        :src="scrtc_path"
        frameborder="0"
        ref="scrtc_iframe"
      />
    </div>
  </div>
</template>
<script>
import Header from '../components/Header/HeaderLearning.vue'


export default {
  name: 'Learning',
  components: {
    'Header': Header
  },
  data () {
    return {
      isLoading: true,
      isIE: false,
      cntLoading: 0,
      txtLoading: '잠시만 기다려 주십시요.',
      scrtc_iframe: '',
      scrtc_path: '',
      isLctreLoading: false
    }
  },
  /** Scratch Library를 해당 View에서만 독립적으로 Import(하단방식도 정상동작) **/
  mounted () {
    const BROWSER_TYPE = navigator.userAgent.toLowerCase();
    // console.log(`[Workspace::mounted] BROWSER TYPE : ${BROWSER_TYPE}`);
    if
      (
      BROWSER_TYPE.indexOf('trident/') > -1       // IE 11
      || BROWSER_TYPE.indexOf('msie 10.0') > -1   // IE 10
      || BROWSER_TYPE.indexOf('msie 9.0') > -1    // IE 9
      || BROWSER_TYPE.indexOf('msie 8.0') > -1    // IE 8
      || BROWSER_TYPE.indexOf('msie 7.0') > -1    // IE 7
    ) {
      this.isIE = true;
      return;
    } else {
      // console.log(`[Workspace::mounted] IE Not Detected!`);
    }

    if (window.VUE_APP_NODE_ENV === 'development') {
      //this.scrtc_path = '/scrtc/main';
      this.scrtc_path = '/blk-sc/scrtc/main';
      console.log(`[Scrtch::Workspace.vue] Dev - scrtch_path : ${this.scrtc_path}`);
    } else {
      this.scrtc_path = '/blk-sc/scrtc/main';
      console.log(`[Scrtch::Workspace.vue] Test&Prod - scrtch_path : ${this.scrtc_path}`);
    }
    this.scrtc_iframe = this.$refs.scrtc_iframe

    // 쿼리스트링내 콘텐츠 순번 여부 체크
    const query = this.$route.query;
    if (query.cntntsSn) {
      console.log(`[Learning] CntntsSn : ${query.cntntsSn}`);
      this.isLctreLoading = true;
    }

    // 스크래치 라이브러리 최초 로딩시 시간이 걸리므로 로딩안내창을 띄움 
    // 스크래치 iFrame창 로딩시 원래 로딩관련 Div 숨김처리
    let that = this;
    const iframe = document.getElementById('scrtc_iframe');
    iframe.onload = () => {
      // alert('Contents Loaded!');
      that.isLoading = false;


      /**
       *  화면이 최초 로딩시 작품정보를 서버로부터 수신하면서 Scratch 라이브러리도 함께 로딩중인 상황일 경우 자식 컴포넌트(HeaderPrctice)의 함수를 호출하여 스크래치 프로젝트 강제로딩 처리 
       */
      if (that.isLctreLoading) {
        // console.log(`[Workspace::mounted] isPrdctLoading === true | 작품로딩중[나의 작품+타인의 작품]`);
        //that.$refs.headerPrctice.scratchReload();
      } else {
        // console.log(`[Workspace::mounted] isPrdctLoading === false | 작품로딩중[실습방]`);
      }
    }

    // 초당 한번씩 로딩 메시지 업데이트
    let v = this;
    var ck = setInterval(function () {
      // 문구 로딩 종료
      if (!v.isLoading) {
        clearInterval(ck);
        that.$EventBus.$emit("Learning Loading Complete");
      }
      // 문구 업데이트
      else {
        ++v.cntLoading;
        let remain = v.cntLoading % 3;
        // console.log('[cntLoading : '+v.cntLoading+' | remain : '+remain)
        switch (remain) {
          case 0: v.txtLoading = '잠시만 기다려 주십시요.'; break;
          case 1: v.txtLoading = '잠시만 기다려 주십시요..'; break;
          case 2: v.txtLoading = '잠시만 기다려 주십시요...'; break;
        }
      }
    }, 1000);
  },
  methods: {
    closeLoading () {
      //alert(`[Workspace::closeLoading] Called!`);
      this.isLoading = false;
    }
  }
}
</script>
<style lang="scss">
.prctice {
  position: absolute;
  width: 100%;
  height: 100%;
}
.learning {
  position: absolute;
  width: 100%;
  height: 100%;
}
.scrtc_main {
  position: absolute;
  width: 100%;
  height: calc(100vh - 50px);
  background-color: #5096f5;
}
.scrtc_loading_show {
  width: 100%;
  height: 100%;
  background-color: #5096f5;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;

  .loading_text {
    color: #fff;
    font-weight: 900;
    font-size: 25px;
    font-family: "Noto Sans KR";
    vertical-align: middle;
  }
}
.scrtc_loading_hide {
  width: 0%;
  height: 0%;
  display: none;
  background-color: #5096f5;
}
.scrtc_iframe {
  width: 100%;
  height: 100%;
  display: block;
}
.scrtc_iframe_hide {
  width: 100%;
  height: 100%;
  display: none;
}
.scrtc_iframe_show {
  width: 100%;
  height: 100%;
  display: block;
}
.scrtc_ie_header {
  width: 100%;
  height: 50px;
  background-color: #5096f5;
  overflow: visible;
}
.scrtc_ie_broswer {
  color: #575e75;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -250px;
  margin-left: -250px;
  width: 500px;
  height: 500px;
  background-color: #ffffff;
  border-radius: 8px;
}
.scrtc_ie_broswer_header {
  width: 100%;
  height: 208px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-image: url("../assets/images/unsupported.png");
  background-repeat: no-repeat;
  background-size: cover;
}
.scrtc_ie_broswer_contents {
  font-size: 1.1rem;
  height: 70px;
  margin-top: 15px;
  margin-bottom: 15px;
  padding-top: 30px;
  text-align: center;
}
.scrtc_ie_broswer_footer {
  font-size: 0.9rem;
  text-align: center;
  line-height: 2rem;
  margin-top: 40px;
  padding-left: 25px;
  padding-right: 25px;
}
</style>